/** Status + FastAPI `detail` from a ky HTTPError (or nothing). */
export async function httpError(err: unknown): Promise<{ status?: number; detail?: string }> {
  const response = (err as { response?: Response })?.response;
  if (!response) return {};
  try {
    const body = (await response.clone().json()) as { detail?: unknown };
    return { status: response.status, detail: typeof body.detail === "string" ? body.detail : undefined };
  } catch {
    return { status: response.status };
  }
}
